function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsGroup = void 0;
Object.defineProperty(exports, "StepsGroupController", {
  enumerable: true,
  get: function get() {
    return _StepsGroupController.StepsGroupController;
  }
});
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _FilterGroup = require("../FilterGroup");
var _StepsGroupController = require("./StepsGroupController");
var _styles2 = require("../../styles");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _models = require("../../models");
var _components = require("../../components");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["item", "style", "commitments", "categoryPillOnPress"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var FilterGroupThemeEventKey = 'FilterGroupThemeEventKey';
var _ItemTemplate = (0, _react.memo)(function (_ref) {
  var _commitments$find;
  var item = _ref.item,
    style = _ref.style,
    commitments = _ref.commitments,
    categoryPillOnPress = _ref.categoryPillOnPress,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  return (0, _jsxRuntime.jsx)(_components.StepCardTemplate, Object.assign({
    action: item,
    categoryPillOnPress: categoryPillOnPress,
    style: style,
    commitmentState: commitments == null ? void 0 : (_commitments$find = commitments.find(function (commitment) {
      return commitment.action.id === item.id && commitment.state !== _models.CommitmentState.abandoned;
    })) == null ? void 0 : _commitments$find.state,
    isCardContentCentred: bp.tablet,
    hideAbandon: true
  }, props));
});
var StepsGroup = exports.StepsGroup = (0, _react.memo)(function (_ref2) {
  var _ref2$controller = _ref2.controller,
    controller = _ref2$controller === void 0 ? new _StepsGroupController.StepsGroupController() : _ref2$controller,
    scrollViewRef = _ref2.scrollViewRef,
    _ref2$selectedFilters = _ref2.selectedFilters,
    selectedFilters = _ref2$selectedFilters === void 0 ? [] : _ref2$selectedFilters,
    onFilterChange = _ref2.onFilterChange,
    _ref2$selectedState = _ref2.selectedState,
    selectedState = _ref2$selectedState === void 0 ? _models.StepState.applicable : _ref2$selectedState,
    onStateChange = _ref2.onStateChange;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasCheckedInitialFilter = (0, _react.useRef)(false);
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents;
  var _useScrollTo = (0, _utils.useScrollTo)({
      scrollViewRef: scrollViewRef
    }),
    scrollTo = _useScrollTo.scrollTo;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _controller$useContro = controller.useController({
      selectedState: selectedState
    }),
    steps = _controller$useContro.steps,
    isLoadingSteps = _controller$useContro.isLoadingSteps,
    isFetchingSteps = _controller$useContro.isFetchingSteps,
    themeFilters = _controller$useContro.themeFilters,
    impactFilters = _controller$useContro.impactFilters,
    commitments = _controller$useContro.commitments,
    recommendedSteps = _controller$useContro.recommendedSteps,
    isLoadingRecommendedSteps = _controller$useContro.isLoadingRecommendedSteps;
  var _trackingSource = (0, _react.useMemo)(function () {
    switch (selectedState) {
      case _models.StepState.complete:
        return 'Completed';
      case _models.StepState.applicable:
        return 'Applicable';
      case _models.StepState.existing:
        return 'Existing';
      default:
        return '';
    }
  }, [selectedState]);
  var _hasSelectedFilters = selectedFilters.filter(function (item) {
    return !!item;
  }).length > 0;
  var _listRef = (0, _react.useRef)(null);
  var _listY = (0, _react.useRef)(0);
  var _impactFiltersY = (0, _react.useRef)(0);
  var _impactFiltersSlugs = (0, _react.useMemo)(function () {
    return (impactFilters == null ? void 0 : impactFilters.map(function (item) {
      return item.lookupSlug;
    })) || [];
  }, [impactFilters]);
  var _themeFiltersY = (0, _react.useRef)(0);
  var _themeFiltersSlugs = (0, _react.useMemo)(function () {
    return (themeFilters == null ? void 0 : themeFilters.map(function (item) {
      return item.lookupSlug;
    })) || [];
  }, [themeFilters]);
  var _scrollToFilterGroup = (0, _react.useCallback)(function (slug) {
    var _hasImpact = false;
    var _hasTheme = false;
    if (slug) {
      if (_impactFiltersSlugs.includes(slug)) {
        _hasImpact = true;
      }
      if (_themeFiltersSlugs.includes(slug)) {
        _hasTheme = true;
      }
    } else {
      selectedFilters.forEach(function (filter) {
        if (_impactFiltersSlugs.includes(filter)) {
          _hasImpact = true;
        }
        if (_themeFiltersSlugs.includes(filter)) {
          _hasTheme = true;
        }
      });
    }
    if (_hasImpact && _hasTheme) {
      scrollTo(_listY.current);
    } else if (_hasImpact) {
      scrollTo(_listY.current + _impactFiltersY.current);
    } else if (_hasTheme) {
      scrollTo(_listY.current + _themeFiltersY.current);
    }
  }, [_impactFiltersSlugs, _themeFiltersSlugs, selectedFilters, scrollTo]);
  var _checkInitialFilters = function _checkInitialFilters() {
    if (_hasCheckedInitialFilter.current) return;
    if (_listY.current === 0 || _impactFiltersY.current === 0 || _themeFiltersY.current === 0) return;
    _hasCheckedInitialFilter.current = true;
    if (_hasSelectedFilters) {
      (0, _FilterGroup.ToggleFilterGroup)({
        eventKey: FilterGroupThemeEventKey,
        showMore: true
      });
      _scrollToFilterGroup();
    }
  };
  var _onLayout = function _onLayout(_ref3) {
    var y = _ref3.nativeEvent.layout.y;
    if (_listY.current !== y && y > 0) {
      _listY.current = y;
    }
    _checkInitialFilters();
  };
  var _impactFilterGroupOnLayout = function _impactFilterGroupOnLayout(_ref4) {
    var y = _ref4.nativeEvent.layout.y;
    if (_impactFiltersY.current !== y && y > 0) {
      _impactFiltersY.current = y;
    }
    _checkInitialFilters();
  };
  var _themeFilterGroupOnLayout = function _themeFilterGroupOnLayout(_ref5) {
    var y = _ref5.nativeEvent.layout.y;
    if (_themeFiltersY.current !== y && y > 0) {
      _themeFiltersY.current = y;
    }
    _checkInitialFilters();
  };
  var _updateFilters = (0, _react.useCallback)(function (_ref6) {
    var slug = _ref6.slug,
      _ref6$isToggle = _ref6.isToggle,
      isToggle = _ref6$isToggle === void 0 ? false : _ref6$isToggle;
    var _selectedFilters = (0, _toConsumableArray2["default"])(selectedFilters);
    var _index = _selectedFilters.findIndex(function (item) {
      return item === slug;
    });
    if (isToggle && _index > -1) {
      _selectedFilters.splice(_index, 1);
    } else if (_index === -1) {
      _selectedFilters.push(slug);
    }
    onFilterChange == null ? void 0 : onFilterChange(_selectedFilters);
  }, [onFilterChange, selectedFilters]);
  var _updateState = function _updateState(value) {
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        type: 'state',
        source: 'filter',
        slug: value
      }
    });
    onStateChange == null ? void 0 : onStateChange(value);
  };
  var _impactFiltersOnPress = function _impactFiltersOnPress(slug) {
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        type: 'impact',
        source: 'filter',
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    _updateFilters({
      slug: slug,
      isToggle: true
    });
  };
  var _themeFiltersOnPress = function _themeFiltersOnPress(slug) {
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        type: 'theme',
        source: 'filter',
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    _updateFilters({
      slug: slug,
      isToggle: true
    });
  };
  var _categoryPillOnPress = (0, _react.useCallback)(function (slug) {
    var _isImpact = !!(impactFilters != null && impactFilters.find(function (item) {
      return item.lookupSlug === slug;
    }));
    var _slugType = _isImpact ? 'impact' : 'theme';
    trackEvent({
      eventName: trackingEvents.stepFilter,
      props: {
        source: 'category',
        type: _slugType,
        slug: slug,
        toggled: selectedFilters.includes(slug)
      }
    });
    (0, _FilterGroup.ToggleFilterGroup)({
      eventKey: FilterGroupThemeEventKey,
      showMore: true
    });
    _scrollToFilterGroup(slug);
    _updateFilters({
      slug: slug
    });
  }, [_scrollToFilterGroup, _updateFilters, impactFilters, selectedFilters, trackEvent, trackingEvents.stepFilter]);
  var _filteredSteps = (0, _react.useMemo)(function () {
    if (!_hasSelectedFilters) {
      return steps;
    }
    var _impactFilters = (impactFilters == null ? void 0 : impactFilters.filter(function (item) {
      return selectedFilters.includes(item.lookupSlug);
    }).map(function (item) {
      return item.lookupSlug;
    })) || [];
    var _themeFilters = (themeFilters == null ? void 0 : themeFilters.filter(function (item) {
      return selectedFilters.includes(item.lookupSlug);
    }).map(function (item) {
      return item.lookupSlug;
    })) || [];
    var _items = steps == null ? void 0 : steps.filter(function (item) {
      var _item$themes$map, _item$themes;
      var _impact = item.impact.lookupSlug;
      var _themes = (_item$themes$map = (_item$themes = item.themes) == null ? void 0 : _item$themes.map(function (themeItem) {
        return themeItem.theme.lookupSlug;
      })) != null ? _item$themes$map : [];
      var _hasImpact = false;
      var _hasTheme = false;
      if (_impactFilters.length === 0) {
        _hasImpact = true;
      } else {
        _hasImpact = _impactFilters.includes(_impact);
      }
      if (_themeFilters.length === 0) {
        _hasTheme = true;
      } else if (_themes.length > 0) {
        _themes.forEach(function (theme) {
          if (_themeFilters.includes(theme)) {
            _hasTheme = true;
          }
        });
      }
      return _hasImpact && _hasTheme;
    });
    return _items;
  }, [_hasSelectedFilters, impactFilters, selectedFilters, steps, themeFilters]);
  (0, _react.useEffect)(function () {
    if (isLoading && !isLoadingRecommendedSteps && !isLoadingSteps) {
      setIsLoading(false);
    }
  }, [isLoading, isLoadingRecommendedSteps, isLoadingSteps]);
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {
      testID: "ActivityIndicatorSteps"
    });
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.container_noHeader
    }), !!recommendedSteps && recommendedSteps.length > 0 && (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: [styles.section],
      testID: "RecommendedSteps",
      children: (0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
        value: {
          source: 'Find Steps Recommended Steps'
        },
        children: (0, _jsxRuntime.jsx)(_components.StepCarousel, {
          totalItems: steps == null ? void 0 : steps.length,
          items: recommendedSteps,
          ItemTemplate: function ItemTemplate(props) {
            return (0, _jsxRuntime.jsx)(_ItemTemplate, Object.assign({}, props, {
              commitments: commitments,
              categoryPillOnPress: _categoryPillOnPress
            }));
          },
          title: t('stepsGroup:recommendedSteps.title'),
          testID: "RecommendedStepsCarousel"
        })
      })
    }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: [styles.container],
      testID: "StepsGroup",
      ref: _listRef,
      onLayout: _onLayout,
      children: [(0, _jsxRuntime.jsx)(_components.Heading, {
        level: 1,
        style: styles.heading,
        children: t('stepsGroup:title')
      }), (0, _jsxRuntime.jsx)(_components.TabNavigation, {
        style: styles.tabs,
        items: Object.keys(_models.StepState).map(function (key) {
          return {
            label: t("stepsGroup:filters.tabs.".concat(key)),
            onPress: function onPress() {
              return _updateState(_models.StepState[key]);
            },
            active: selectedState === key
          };
        })
      }), impactFilters && (0, _jsxRuntime.jsx)(_FilterGroup.FilterGroup, {
        testID: "FilterGroupImpact",
        title: t('stepsGroup:filters.impact.title'),
        onPress: _impactFiltersOnPress,
        items: impactFilters.map(function (item) {
          return {
            slug: item.lookupSlug,
            label: item.name
          };
        }),
        style: styles.filterGroup,
        selectedItems: selectedFilters,
        onLayout: _impactFilterGroupOnLayout
      }), themeFilters && (0, _jsxRuntime.jsx)(_FilterGroup.FilterGroup, {
        testID: "FilterGroupTheme",
        title: t('stepsGroup:filters.theme.title'),
        onPress: _themeFiltersOnPress,
        items: themeFilters.map(function (item) {
          return {
            slug: item.lookupSlug,
            label: item.name
          };
        }),
        showMoreLabel: t('stepsGroup:filters.theme.showMoreLabel'),
        showLessLabel: t('stepsGroup:filters.theme.showLessLabel'),
        style: styles.filterGroup,
        selectedItems: selectedFilters,
        visibleRows: 2,
        onLayout: _themeFilterGroupOnLayout,
        eventKey: FilterGroupThemeEventKey
      }), isFetchingSteps && (0, _jsxRuntime.jsx)(_reactNative.View, {
        style: styles.activityIndicator,
        children: (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {
          testID: "ActivityIndicatorSteps"
        })
      }), !isFetchingSteps && (0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
        value: {
          source: "StepsGroup ".concat(_trackingSource, " Steps")
        },
        children: (0, _jsxRuntime.jsx)(_components.CardList, {
          style: styles.list,
          emptyMessage: t('stepsGroup:list.emptyMessage'),
          items: _filteredSteps,
          ItemTemplate: function ItemTemplate(props) {
            return (0, _jsxRuntime.jsx)(_ItemTemplate, Object.assign({}, props, {
              commitments: commitments,
              categoryPillOnPress: _categoryPillOnPress
            }));
          },
          testID: "StepsList-".concat(selectedState)
        })
      })]
    })]
  });
});